import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '..';
import { restoreAll } from '../restoreAll';
import { diContainer } from '../../libs/container';
import { LANGUAGE, LocalStorage } from '../../util/LocalStorage';

export interface LanguageData {
    [key: string]: any;
}

const languages: LanguageData = {
    english: require('../../data/english.json'),
    serbian: require('../../data/serbian.json'),
};

export interface LanguageState {
    data: LanguageData;
    selected: string;
}

const initialState = (): LanguageState => {
    const storage = diContainer.get(LocalStorage);
    const selectedLanguage = storage.get(LANGUAGE) ?? 'english';
    return {
        data: languages[selectedLanguage],
        selected: selectedLanguage,
    };
};

export const languageSlice = createSlice({
    name: 'language',
    initialState,
    extraReducers: builder => builder.addCase(restoreAll, initialState),
    reducers: {
        setLanguage: (state, action: PayloadAction<string>) => {
            const storage = diContainer.get(LocalStorage);
            storage.set(LANGUAGE, action.payload);
            state.selected = action.payload;
            state.data = languages[action.payload];
        },
    },
});

export const { setLanguage } = languageSlice.actions;

export const selectLanguageData = (state: RootState) => state.language.data;

export default languageSlice.reducer;
